// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../utils/Utils.bs.js");
var ViewStack = require("../../reason/common/ViewStack.bs.js");
var Icon__Jsx3 = require("../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Text__Jsx3 = require("../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../reason/common/Theme/Theme__Color__Vars.bs.js");
var Colors = require("uikit/styles/colors");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var BuyerNeedPropertyAttributes_buyerNeedV5_graphql = require("../../__generated__/BuyerNeedPropertyAttributes_buyerNeedV5_graphql.bs.js");
var BuyerNeedPropertyAttributes_propertyTypes_graphql = require("../../__generated__/BuyerNeedPropertyAttributes_propertyTypes_graphql.bs.js");

var convertFragment = BuyerNeedPropertyAttributes_propertyTypes_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerNeedPropertyAttributes_propertyTypes_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerNeedPropertyAttributes_propertyTypes_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, BuyerNeedPropertyAttributes_propertyTypes_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BuyerNeedPropertyAttributes_propertyTypes_graphql.node, convertFragment, fRef);
}

var PropertyTypeFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function BuyerNeedPropertyAttributes$Attributes(props) {
  var __icon = props.icon;
  var minBeds = props.minBeds;
  var icon = __icon !== undefined ? Caml_option.valFromOption(__icon) : "Home";
  var propertyTypes = use(props.propertyTypes);
  return JsxRuntime.jsxs(ViewStack.make, {
              flexDirection: "row",
              children: [
                JsxRuntime.jsxs(ViewStack.make, {
                      space: "sm",
                      flexDirection: "row",
                      children: [
                        Core__Option.getOr(Core__Option.map(icon, (function (icon) {
                                    return JsxRuntime.jsx(Icon__Jsx3.make, {
                                                icon: icon,
                                                color: Theme__Color__Vars.chicago
                                              });
                                  })), null),
                        JsxRuntime.jsx(Text__Jsx3.make, {
                              color: Colors.mineShaft,
                              children: (function (__x) {
                                      return Utils.$$Array.pseudoJoin(", ", " or ", __x);
                                    })(propertyTypes.map(function (x) {
                                          return x.displayName;
                                        })).join("")
                            })
                      ]
                    }),
                minBeds !== undefined ? JsxRuntime.jsxs(ViewStack.make, {
                        space: "sm",
                        flexDirection: "row",
                        children: [
                          JsxRuntime.jsx(Icon__Jsx3.make, {
                                icon: "Bed",
                                className: "relative top-0.5",
                                color: Theme__Color__Vars.chicago
                              }),
                          JsxRuntime.jsx(Text__Jsx3.make, {
                                color: Colors.mineShaft,
                                children: String(minBeds) + "+"
                              })
                        ]
                      }) : null
              ]
            });
}

var Attributes = {
  PropertyTypeFragment: PropertyTypeFragment,
  make: BuyerNeedPropertyAttributes$Attributes
};

var convertFragment$1 = BuyerNeedPropertyAttributes_buyerNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerNeedPropertyAttributes_buyerNeedV5_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerNeedPropertyAttributes_buyerNeedV5_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, BuyerNeedPropertyAttributes_buyerNeedV5_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(BuyerNeedPropertyAttributes_buyerNeedV5_graphql.node, convertFragment$1, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function BuyerNeedPropertyAttributes(props) {
  var match = use$1(props.buyerNeed);
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "property criteria",
              children: JsxRuntime.jsx(BuyerNeedPropertyAttributes$Attributes, {
                    propertyTypes: match.propertyTypes.map(function (v) {
                          return v.fragmentRefs;
                        }),
                    minBeds: match.minBeds,
                    icon: props.icon
                  })
            });
}

var make = BuyerNeedPropertyAttributes;

exports.Attributes = Attributes;
exports.Fragment = Fragment;
exports.make = make;
/* Utils Not a pure module */
